import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { X, ExternalLink } from 'lucide-react';
import Notes from './Notes';
import './NotesModal.css';

const NotesModal = ({ open, onClose }) => {
  const [view, setView] = useState('list'); // 'list' | 'editor'
  const [expanded, setExpanded] = useState(false);
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!open) return undefined;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const onKey = (e) => { if (e.key === 'Escape') onClose?.(); };
    window.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = prev;
      window.removeEventListener('keydown', onKey);
    };
  }, [open, onClose]);

  // Reset when the modal closes so re-opens start on the list.
  useEffect(() => {
    if (!open) { setView('list'); setExpanded(false); }
  }, [open]);

  if (!open) return null;

  const isEditing = view === 'editor';

  return (
    <div className={`rsn-modal ${isEditing ? 'rsn-modal--editing' : ''} ${expanded ? 'rsn-modal--expanded' : ''}`}
         role="dialog" aria-modal="true" aria-label="Notes">
      <div className="rsn-modal__backdrop" onClick={onClose} aria-hidden="true" />
      <div className="rsn-modal__sheet">
        <div className="rsn-modal__grip" aria-hidden="true" />

        {/* Modal header is only shown on the list view. The editor view has
            its own chrome (back button, save, delete) so the modal stays
            visually clean while writing. */}
        {!isEditing && (
          <header className="rsn-modal__header">
            <div className="rsn-modal__title">
              <span className="rsn-modal__heading">Notes</span>
              {count > 0 && (
                <span className="rsn-modal__count">{count} note{count === 1 ? '' : 's'}</span>
              )}
            </div>
            <div className="rsn-modal__actions">
              <Link
                to="/utilities/notes"
                className="rsn-modal__open"
                onClick={onClose}
                title="Open full page"
              >
                <ExternalLink size={14} aria-hidden="true" />
                <span>Open page</span>
              </Link>
              <button
                type="button"
                className="rsn-modal__close"
                onClick={onClose}
                aria-label="Close"
              >
                <X size={18} aria-hidden="true" />
              </button>
            </div>
          </header>
        )}

        <div className="rsn-modal__body">
          <Notes
            compact
            onClose={onClose}
            onViewChange={({ view: v, expanded: ex, count: c }) => {
              setView(v);
              setExpanded(!!ex);
              if (typeof c === 'number') setCount(c);
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default NotesModal;
